import { RefreshCw } from 'lucide-react';
import { useIsBackgroundSyncing } from '@/hooks/useQueryActivity';

/**
 * Quiet marker for background refreshes of data already on screen. The polling
 * queries fire constantly, so this deliberately stays subtle — it explains a
 * slow-feeling dashboard without competing with the content.
 */
export function SyncIndicator() {
  const syncing = useIsBackgroundSyncing();

  return (
    <span
      className={`flex items-center gap-1.5 text-xs text-muted-foreground transition-opacity duration-300 ${
        syncing ? 'opacity-100' : 'opacity-0'
      }`}
      aria-hidden={!syncing}
    >
      <RefreshCw className="h-3 w-3 animate-spin motion-reduce:animate-none" />
      <span className="hidden sm:inline">Syncing…</span>
    </span>
  );
}
